import type { FaireProductEntity } from "../../entity_types/product";

export const p_456s3qu783: FaireProductEntity = {
  token: "p_456s3qu783",
  type: "product",
  name: "One Cat, Two Cats: A lift-the-flap, pop-up book",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/a72331c7ee64a5be0031209e812859afa7543224b1a3d626aaeca716a80ce5dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e4acffd1fd34407d5c98ef5df4cefdc83ac9af33cf99ae8c2ce732c4889085b.jpeg",
    "https://cdn.faire.com/fastly/6790df8b67da649d7e783e2c2f44be6ba605f1f65e6c2c59d3335f34770e343d.jpeg",
    "https://cdn.faire.com/fastly/55961fe4c6a65da436f76c3ac9cbd9413043a5fc2ed823960b756c2b533c17a2.jpeg",
    "https://cdn.faire.com/fastly/a41da36f0da1a742824a2d54a11c5d66a239b8ae6c7eae5d15ea121ffdd6cd90.jpeg",
    "https://cdn.faire.com/fastly/18099958036719bf6033cd0ceecb2595c65fb5972f1b02f1becc9299f55ebeee.jpeg",
    "https://cdn.faire.com/fastly/22e8f70614756e68468f10e3ef7d8c52117c8cb8f3baaecc929af146d2d307e4.jpeg",
    "https://cdn.faire.com/fastly/83e98543bb46b0dfdcd5e40b959f874d690feb6bde1d30b67f4606c26fa604a9.jpeg"
  ],
  priceDollars: 9,
  description: "Count from one to twenty in this vibrant lift-the-flap pop-up book!\n\nThis joyful, interactive counting picture book has plenty of cat-itude! One cat, two cats, three cats, four. Five cats, six cats . . . how many more? There are 20 funny felines to find in lots of silly, cat-like scenarios, from hiding in boxes to dozing in the sun. Rhyming text, sturdy flaps, and surprising pop-ups with all kinds of kitties make this the purr-fect book for cat lovers, young and old.",
  tags: [],
  msrpDollars: 17.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:19.650Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
